<script setup lang="ts" generic="T">
    // @ts-nocheck
    import { toRefs, ref } from "vue";
    import { EventImpl } from "@fullcalendar/core/internal";
    import TimelineEvent from "@/components/calendars/events/Timeline/TimelineEvent.vue";
    import VardplatsSparraTid from "@/tabs/Vardplatsbokning/VardplatsSparraTid.vue";

    const showSparraTid = ref(false);

    const props = withDefaults(
        defineProps<{
            event: EventImpl;
            data: any;
        }>(),
        {}
    );

    const { data } = toRefs(props);

    const toggleSparraTid = () => {
        showSparraTid.value = !showSparraTid.value;
    };
</script>

<template>
    <TimelineEvent
        class="vardplats-sparrad-tid-timeline-event"
        v-bind="{ ...$attrs, ...$props, ...$slots }"
        variant="sparradTid"
        :enablePanel="false"
        @click="toggleSparraTid"
    >
        <template #inner="{ data }">
            <span>{{ data.orsak_display.namn }}</span>
            <span>{{ data?.kommentar || "" }}</span>

            <VardplatsSparraTid
                :params="data"
                v-if="showSparraTid"
                @created="toggleSparraTid"
                @cancel="toggleSparraTid"
                @deleted="toggleSparraTid"
            />
        </template>
    </TimelineEvent>
</template>
